import { render, staticRenderFns } from "./Ldar.vue?vue&type=template&id=5083959c&scoped=true"
import script from "./Ldar.vue?vue&type=script&lang=js"
export * from "./Ldar.vue?vue&type=script&lang=js"
import style0 from "./Ldar.vue?vue&type=style&index=0&id=5083959c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083959c",
  null
  
)

export default component.exports